var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurants(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#D9EBC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8477 29.8477V24.8477M28.8477 24.8477V11.8477C28.8477 11.8477 23.8477 14.8477 23.8477 24.8477H28.8477Z",
    stroke: "#69A42E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8477 11.8477V18.8477M16.8477 29.8477V18.8477M16.8477 18.8477V18.8477C18.5045 18.8477 19.8477 17.5045 19.8477 15.8477V11.8477M16.8477 18.8477V18.8477C15.1908 18.8477 13.8477 17.5045 13.8477 15.8477V11.8477",
    stroke: "#69A42E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurants);
export default __webpack_public_path__ + "static/media/restaurants.cd07d88c10adc5521e35633b1b50cbc1.svg";
export { ForwardRef as ReactComponent };